import * as React from 'react';
import { Overlay, SideModal, SideModalContent } from '~/common/layout/Modals';
import Head from '~/common/layout/Head';

import LocationForm from './LocationForm';

export default (props) => {
  const { headTitle, onClose, onSubmit, location } = props;

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <Overlay onClick={handleClose}>
      <SideModal>
        <Head headTitle={headTitle} />

        <SideModalContent>
          <LocationForm onSubmit={onSubmit} initialValues={location} />
        </SideModalContent>
      </SideModal>
    </Overlay>
  );
};
